export default "__VITE_ASSET__DNPCzh6D__"